export const locale = {
  lang: 'nl',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1':'Download de vragensjabloon',
        'INST_2':'Breng de nodige wijzigingen aan in de vraagsjabloon',
        'INST_3':'Laad de vraagsjabloon',
        "BTN_DESC_PLAN": "Vragensjabloon",
        'BUSC_PLAN_TEX':'Klik hier om te zoeken naar de sjabloonvragen',
        'TEMP_CARG_TIT':'Sjablooninformatie',
        'TOT_PREG':'Totaal vragen',
        'TOT_PREG_MODI':'Totaal gewijzigde vragen',
        'TOT_PREG_NUE': 'Totaal nieuwe vragen',
        'TEMP_CARG_TIT_CAR':'Sjablooninformatie geladen',
        'COMPL_PAS_SIN_MODI':'U hebt nog geen wijziging aangebracht. U dient de stap te voltooien?',
        'SUCC_CAR_PLAN':'De sjabloon is met succes geladen. Voltooi de stap alstublieft',
        'COMPLE_PASO_CON_MODI': 'Weet u zeker dat u de stap wilt voltooien met de momenteel ingevoerde wijzigingen?',
        'NO_MODIF':'Wijzig deze celinhoud niet',
        'ERROR_CARGA':'Het bestand kan niet worden geüpload, wijzigingen zijn gedetecteerd in een of meer beperkte cellen, download de sjabloon opnieuw en breng de gewenste wijzigingen aan zonder de beperkte cellen te wijzigen.\n\nBeperkte cellen bevatten een opmerking die aangeeft dat hun inhoud niet mag worden gewijzigd',
        'FORALL_EXCEDIDAS': 'Er werd vastgesteld dat het aantal trainingen dat 4All aanwezig is in de geladen sjabloon het aantal toegestane trainingen overschrijdt, alleen de trainingen die overeenkomen met het maximaal toegestane aantal zijn geladen ',
        'OPCIONDEMOGRAFICOS': 'Deze cel moet een ongewijzigde waarde uit het demografische catalogusblad bevatten',
        'CARGANDO_PREGUNTAS': 'Vragen laden vanuit de sjabloon'
      },
      'CATALOGO_IDIOMAS':{
        'z1': 'Vereenvoudigd Chinees',
        'z2': 'Traditioneel Chinees',
        'ko': 'Koreaans',
        'ja': 'Japans',
        'pt': 'Portugees',
        'en':'Engels',
        'fr':'Frans',
        'de': 'Duits',
        'it': 'Italiaans',
        'es': 'Spaans',
        'tr': 'Turks',
        'ms': 'Maleis',
        'ro': 'Roemeens',
        'vi': 'Vietnamees',
        'bg': 'Bulgaars',
        'hi': 'Hindi',
        'ru': 'Russisch',
        'mn': 'Mongools',
        'nl': 'Nederlands',
        'ar': 'Arabisch',
        'ua': 'Oekraïens',
        'id': 'Indonesisch',
      },
      'HOJAS_EXCEL':{
       'Instrucciones': 'Instructies',
       'Catalogo': 'Catalogus',
       'Detalles': 'Details',
       'CatDemograficos': 'Demografische catalogus',
       'Nps': 'Nps',
       'Reactivos': 'Verklaringen',
       'Control': 'Control',
       'Demograficos': 'Demografics',
       'Abiertas':'Open',
       'Forall':'Forall',
       'Adicionales': 'Additioneel',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas': 'LanguageKey',
       'NombreIdiomas':'LanguageName',
       'IDTipoPregunta': 'ID type vraag',
       'TiposPreguntas': 'Vraagtypes',
       'ClaveTipoElemento': 'Sleutel voor elementtype',
       'TiposElementos': 'Elementtypes',
       'CONTEM_TIP_PREG':{
         '1': 'NPS / Controle / Aanvullende vraag (meerkeuze, één antwoord)',
         '2_1': 'NPS / Controle / vraag met open einde, type open tekst',
         '2_2': 'NPS / Controle / open vraag, type numerieke tekst',
         '3': 'Vraag van het reactieve type',
         '4': 'Demografische type vraag (meerkeuze, één antwoord)',
         '5': 'Praktijk 4All',
         '6': 'Extra vraag (meerkeuze, meerdere antwoorden)',
       },
       'CONTEM_TIP_SEGM':{
         'question': 'Tekst van de vraag',
         'answer_1': 'Tekst van antwoord 1',
         'answer_2': 'Tekst van antwoord 2',
         'answer_n': 'Tekst van antwoord n',
         'practice': 'Tekst van praktijk 4All',
         'description': 'Tekst van beschrijving van praktijk 4All',
         'statement_1': 'Vraag 1 van praktijk 4All',
         'statement_2': 'Vraag 2 van praktijk 4All',
       }
     },
     'COLUMNAS_SECCION':{
      'Id': 'Id',
      'TipoDePregunta': 'QuestionType',
      'PalabrasClave': 'KeyWords',
      'NuevaPregunta': 'NewQuestion',
      'Eliminable':	'Elimineerbaar',
      'Editable':	'Bewerkbaar',
      'RespuestaObligatoria':	'VerplichtAntwoorden',
      'MostrarPregunta': 'ShowQuestion',
      'Dimension': 'Maat',
      'Competencia':	'Competentie',
      'Subcompetencia':	'Subcompetentie',
      'TipoDemografico': 'TypeDemografico',
      'practice': 'praktijk',
      'description': 'beschrijving',
      'statement_1': 'verklaring_1',
      'statement_2': 'verklaring_2',
      'question': 'vraag',
      'answer': 'antwoord',
      'OpcionOtro': 'Antwoordtype "Anders"'

     }
    }
  }
};
